import React from "react";

import { VehiclesPicker } from "../VehiclesPicker";
import { DatesIntervalButton } from "../DatesIntervalButton";
import { FleetPickerDropdown } from "../FleetPickerDropdown";

import {
  AsideFiltersWrapperStyled,
  SemanticMapPickerPaddingStyled,
} from "./styles";
import { DelimiterStyled } from "../../../common/Delimeter/styles";
import { SemanticMapPicker } from "Components/common/SemanticMapPicker";

interface AsideFiltersProps {
  showVehiclesAndDates?: boolean;
}

export const AsideFilters = ({
  showVehiclesAndDates = true,
}: AsideFiltersProps) => (
  <AsideFiltersWrapperStyled>
    <SemanticMapPickerPaddingStyled>
      <SemanticMapPicker />
    </SemanticMapPickerPaddingStyled>
    <DelimiterStyled />
    <FleetPickerDropdown />
    {showVehiclesAndDates && (
      <>
        <DelimiterStyled />
        <VehiclesPicker />
        <DatesIntervalButton />
      </>
    )}
  </AsideFiltersWrapperStyled>
);
